import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CloseIcon from "@mui/icons-material/Close";
import { TabView, TabPanel } from "primereact/tabview";
import axios from "axios";
import NouvellesNavettes from "./navette/nouvellesNavette";
import EnCours from "./navette/encoursNavette";
import Termines from "./navette/terminesNavettes";
import EnAttentes from "./navette/enAttentes";
import {TextareaAutosize } from "@mui/material";
import { Dialog } from "primereact/dialog";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import "primeicons/primeicons.css";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import {Calendar} from "primereact/calendar";
import { addLocale, locale } from 'primereact/api';

addLocale('fr', {
    firstDayOfWeek: 1,
    dayNames: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
    dayNamesShort: ['dim', 'lun', 'mar', 'mer', 'jeu', 'ven', 'sam'],
    dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
    monthNames: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'],
    monthNamesShort: ['janv', 'févr', 'mars', 'avr', 'mai', 'juin', 'juil', 'août', 'sept', 'oct', 'nov', 'déc'],
    today: 'Aujourd\'hui',
    clear: 'Effacer'
});

const apiUrl = process.env.REACT_APP_API_URL;
export default function Navettes() {

const [visible, setVisible] = useState(false);





const [activeIndex, setActiveIndex] = useState(() => {
    const savedIndex = localStorage.getItem("activeNavetteTab");
    return savedIndex !== null ? parseInt(savedIndex, 10) : 0;
  });

const handleTabChange = (e) => {
    setActiveIndex(e.index);
    localStorage.setItem("activeNavetteTab", e.index);
  };

const trajetOptions = [
    { label: "Aller simple", value: "Aller simple" },
    { label: "Aller-Retour", value: "Aller - Retour" },
    // { label: 'Mise à disposition', value: 'Mise à disposition' }
  ];

   const trajetDetail = [
    {
      label: "Dom ➜ Aero",
      value: "Depuis mon domicile à l'Aéroport Roland-Garros (RUN)",
    },
    {
      label: "Aero ➜ Dom",
      value: "De l'Aéroport Roland-Garros (RUN) à mon domicile",
    },
  ];


const [nom, setNom] = useState("");
const [typeTrajet, setTypeTrajet] = useState("");
const [tel,setTel] = useState("");
const [detailTrajet,setDetailTrajet] = useState("");
const [adresse,setAdresse ] = useState("");
const [ville,setVille] = useState("");
const [total,setTotal] = useState("");
const [paye,setPaye ] = useState("");

const [nb_bag_soute,setNb_bag_soute ] = useState("");
const [nb_bag_cabine,setNb_bag_cabine ] = useState("");
const [infoSup,setInfoSup] = useState("");
const [note,setNote] = useState("");
const [nb_passager,setNb_passager] = useState("");

const [dateDepart,setDateDepart] = useState("");
const [heureDepart, setHeureDepart] = useState("");



const handleValidate = () => {
  const formattedDate = dateDepart instanceof Date ? dateDepart.toISOString().split('T')[0] : null;
  const formattedHeure = heureDepart instanceof Date ? heureDepart.toTimeString().split(' ')[0] : null;

  const data = {
    nomPrenom: nom,
    typeTrajet: typeTrajet,
    tel: tel,
    detailTrajet: detailTrajet,
    adresse: adresse,
    ville: ville, 
    total: total,
    paye: paye,
    nb_bag_soute: nb_bag_soute,
    nb_bag_cabine: nb_bag_cabine,
    infoSup: infoSup,
    note: note,
    nb_passager: nb_passager,
    dateDepart: formattedDate,
    heureDepart: formattedHeure,
    adminNote: localStorage.getItem("us")
  };



  axios.post(`${apiUrl}IHM/api/postUpdate/insertFicheNavette.php`, data)
    .then(res => {
      if(res.data.success) {
        setVisible(false);


setNom("");
setTypeTrajet("");
setTel("");
setDetailTrajet("");
setAdresse("");
setVille("");
setTotal("");
setPaye("");
setNb_bag_soute("");
setNb_bag_cabine("");
setInfoSup("");
setNote("");
setNb_passager("");
setDateDepart("");
setHeureDepart("");



      }
    })
    .catch(err => console.error(err));
}


  return (
    <div>
      <div className="w-full flex justify-content-end mb-2">
        <Button
          label="Ajouter une nouvelle fiche"
          icon="pi pi-plus"
          onClick={() => setVisible(true)}
          className="p-button-outlined"
        />
      </div>

      <Dialog
        blockScroll
        visible={visible}
        header="Nouvelle fiche de navette"
        className="custom-dialog"
        style={{ width: "40vw" }}
        modal
        onHide={() => setVisible(false)}
        breakpoints={{ "960px": "100vw", "640px": "100vw" }}
      >
        <div className="p-3">
          <div className="grid">
            <div className="col-12 md:col-6">
              <label className="font-bold block mb-2 text-sm text-600">
                Nom et Prénoms
              </label>
              <div className="p-inputgroup">
                <InputText
                  value={nom}
                  onChange={(e) => setNom(e.target.value)}
                  placeholder="Nom du client"
                />
              </div>
            </div>

            <div className="col-12 md:col-6 mb-3">
              <label className="font-bold block mb-2 text-sm text-600">
                Type de trajet
              </label>
              <Select
                value={typeTrajet}
                onChange={(e) => setTypeTrajet(e.target.value)}
                displayEmpty
                style={{ width: "100%", height: "40px" }}
              >
                <MenuItem value="" disabled>
                  Sélectionner type
                </MenuItem>
                {trajetOptions.map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </div>

          {/* Ligne 2 */}
          <div className="grid">
            <div className="col-12 md:col-6">
              <label className="font-bold block mb-2 text-sm text-600">
                Téléphone
              </label>
              <div className="p-inputgroup">
                <InputText
                  value={tel}
                  onChange={(e) => setTel(e.target.value)}
                  placeholder="Ex: 06..."
                />
              </div>
            </div>

            <div className="col-12 md:col-6">
              <label className="font-bold block mb-2 text-sm text-600">
                Détail du trajet
              </label>
              <Select
                value={detailTrajet}
                onChange={(e) => setDetailTrajet(e.target.value)}
                displayEmpty
                style={{ width: "100%", height: "40px" }}
              >
                <MenuItem value="" disabled>
                  Sélectionner détail du trajet
                </MenuItem>
                {trajetDetail.map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </MenuItem>
                ))}
              </Select>
            </div>
          </div>

          {/* Ligne 3 */}
          <div className="grid">
            <div className="col-12 md:col-6">
              <label className="font-bold block mb-2 text-sm text-600">
                Adresse
              </label>
              <InputText
                value={adresse}
                onChange={(e) => setAdresse(e.target.value)}
                placeholder="Adresse"
              />
            </div>

            <div className="col-12 md:col-6">
              <label className="font-bold block mb-2 text-sm text-600">
                Ville
              </label>
              <InputText
                value={ville}
                onChange={(e) => setVille(e.target.value)}
                placeholder="Ville"
              />
            </div>
          </div>

          <div className="grid">
            <div className="col-12 md:col-6">
              <label className="font-bold block mb-2 text-sm text-600">
                Prix course
              </label>
              <InputNumber
                value={total}
                mode="currency"
                currency="EUR"
                onChange={(e) => setTotal(e.value)}
                placeholder="0"
              />
            </div>

            <div className="col-12 md:col-6">
              <label className="font-bold block mb-2 text-sm text-600">
                Somme payé
              </label>
              <InputNumber
                value={paye}
                onChange={(e) => setPaye(e.value)}
                mode="currency"
                currency="EUR"
                placeholder="0"
              />
            </div>
          </div>

          <div className="grid">
            <div className="col-12 md:col-6">
              <label className="font-bold block mb-2 text-sm text-600">
                Date départ
              </label>
              <Calendar
                value={dateDepart}
                onChange={(e) => setDateDepart(e.value)}

                inputMode="none"
                locale="fr"
                dateFormat="dd/mm/yy"
              />
            </div>

            <div className="col-12 md:col-6">
              <label className="font-bold block mb-2 text-sm text-600">
                Heure de départ
              </label>
              <Calendar
                id="calendar-timeonly"
                value={heureDepart}
                onChange={(e) => setHeureDepart(e.value)}
                timeOnly
                showSeconds={false}
                inputMode="none"
              />
            </div>
          </div>

          <div className="grid">
            <div className="col-12 md:col-6">
              <label className="font-bold block mb-2 text-sm text-600">
                Nb bagages soute
              </label>
              <InputNumber
                value={nb_bag_soute}
                onChange={(e) => setNb_bag_soute(e.value)}
                placeholder="0"
              />
            </div>

            <div className="col-12 md:col-6">
              <label className="font-bold block mb-2 text-sm text-600">
                Nb bagages cabine
              </label>
              <InputNumber
                value={nb_bag_cabine}
                onChange={(e) => setNb_bag_cabine(e.value)}
                placeholder="0"
              />
            </div>
          </div>

          <div className="grid">
            <div className="col-12 md:col-6">
              <label className="font-bold block mb-2 text-sm text-600">
                Nb passagers
              </label>
              <InputNumber
                value={nb_passager}
                onChange={(e) => setNb_passager(e.value)}
                placeholder="0"
              />
            </div>
          </div>

          <div className="grid">
            <div className="col-12 md:col-12">
              <div className="py-0 px-0 border-round-sm surface-100 flex flex-column">
                <span className="font-bold">
                  Informations suplémentaires sur le vol :
                </span>
              </div>
            </div>
          </div>

          <div className="grid">
            <div className="col-12 md:col-12">
              <TextareaAutosize
                variant="standard"
                minRows={5}
                maxRows={10}
                value={infoSup}
                onChange={(e) => setInfoSup(e.target.value)}
                style={{ width: "100%", borderRadius: "5px" }}
                className="mt-2"
              />
            </div>
          </div>

          <div className="grid">
            <div className="col-12 md:col-12">
              <div className="py-0 px-0 border-round-sm surface-100 flex flex-column">
                <span className="font-bold">Ajouter une note :</span>
              </div>
            </div>
          </div>

          <div className="grid">
            <div className="col-12 md:col-12">
              <TextareaAutosize
                variant="standard"
                minRows={5}
                maxRows={10}
                value={note}
                onChange={(e) => setNote(e.target.value)}
                style={{ width: "100%", borderRadius: "5px" }}
                className="mt-2"
              />
            </div>
          </div>

          <div className="grid">
            <div className="col-12 md:col-12">
              <div className="border-round-sm surface-100 flex flex-column"></div>
              <Button
                label="Modifier la fiche"
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#094ed8";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#2563eb";
                }}
                className="w-full text-white"
                style={{
                  background: "#2563eb",
                  border: "1px solid #2563eb",
                  padding: "0.75rem",
                  borderRadius: "5px",
                }}
                onClick={() => {
                  handleValidate();
                }}
              />
            </div>
          </div>
        </div>
      </Dialog>

      <TabView activeIndex={activeIndex} onTabChange={handleTabChange}>
        <TabPanel header="Partielles">
          <NouvellesNavettes />
        </TabPanel>

        <TabPanel header="En attentes">
          <EnAttentes />
        </TabPanel>

        <TabPanel header="En cours">
          <EnCours />
        </TabPanel>

        <TabPanel header="Terminées">
          <Termines />
        </TabPanel>
      </TabView>
    </div>
  );
}
